// extracted by mini-css-extract-plugin
module.exports = {"AdSlotBranding__desktopWrap":"bgw_a","AdSlotBranding__desktop":"bgw_b","AdSlotBranding__mobile":"bgw_c"};